// components/ResultCard.jsx
import React from 'react';

const strengthStyles = {
  weak: 'bg-red-100 text-red-800',
  moderate: 'bg-yellow-100 text-yellow-800',
  strong: 'bg-blue-100 text-blue-800',
  'very strong': 'bg-green-100 text-green-800',
};

// const ResultCard = ({ items, support, confidence, lift, strength }) => (
//   <div className="bg-white border p-4 rounded-lg shadow result-card fade-in">
//     <div className=" justify-between mb-2">
//       <h4 className="font-medium text-gray-800">{items.join(' + ')}</h4>
//       <span className={`text-xs px-2 py-1 rounded-full ${strengthStyles[strength]}`}>
//         {strength}
//       </span>
//     </div>
//     <div className="grid grid-cols-3 gap-2 text-sm mt-2">
//       <div className="bg-gray-50 p-2 rounded">
//         <div className="text-xs text-gray-500">Support</div>
//         <div className="font-medium">{support}</div>
//       </div>
//       <div className="bg-gray-50 p-2 rounded">
//         <div className="text-xs text-gray-500">Confidence</div>
//         <div className="font-medium">{confidence}</div>
//       </div>
//       <div className="bg-gray-50 p-2 rounded">
//         <div className="text-xs text-gray-500">Lift</div>
//         <div className="font-medium">{lift}</div>
//       </div>
//     </div>
//   </div>
// );

const ResultCard = ({ items, support, confidence, lift, strength }) => (
  <div className="bg-white border p-4 rounded-lg shadow result-card fade-in">
    <div className="flex justify-between items-start mb-2">
      <div className="flex flex-wrap gap-2">
        {items.map((item, i) => (
          <div key={i} className="flex items-center space-x-1">
            <img
              src={item.image}
              alt={item.product_title}
              className="w-8 h-8 object-cover rounded"
            />
            <span className="text-sm text-gray-700">{item.product_title}</span>
            {i < items.length - 1 && <span className="text-gray-400 font-semibold">+</span>}
          </div>
        ))}
      </div>
      <span className={`text-xs px-2 py-1 rounded-full ${strengthStyles[strength]}`}>
        {strength}
      </span>
    </div>

    <div className="grid grid-cols-3 gap-2 text-sm mt-2">
      <div className="bg-gray-50 p-2 rounded">
        <div className="text-xs text-gray-500">Support</div>
        <div className="font-medium">{support}</div>
      </div>
      <div className="bg-gray-50 p-2 rounded">
        <div className="text-xs text-gray-500">Confidence</div>
        <div className="font-medium">{confidence}</div>
      </div>
      <div className="bg-gray-50 p-2 rounded">
        <div className="text-xs text-gray-500">Lift</div>
        <div className="font-medium">{lift}</div>
      </div>
    </div>
  </div>
);


export default ResultCard;
